module.exports = __webpack_public_path__ + "img/c01_unitstartechhandcart_Normal_ua.f5c8c4ff.webp";